import { render } from "./InterventionalCardiology.vue?vue&type=template&id=1748bd50&scoped=true"
import script from "./InterventionalCardiology.vue?vue&type=script&lang=ts"
export * from "./InterventionalCardiology.vue?vue&type=script&lang=ts"

import "./InterventionalCardiology.vue?vue&type=style&index=0&id=1748bd50&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1748bd50"

export default script